import { cloudEnterpriseEnrollmentErrorApi } from '../clients/cloudEnterpriseEnrollmentErrorApiClient';

export const useEnterpriseEnrollmentErrorApiInit = () =>
  cloudEnterpriseEnrollmentErrorApi.useMutation('post', '/enrollment/v1/init');
